<template>
  <div>
    <b v-if="proc">Processo:</b> {{ proc }}
    <b v-if="classe?.descricao">Classe:</b> {{ classe?.descricao }}
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
import { useClasseJudicialStore } from "@/store/classe-store";

const classeStore = useClasseJudicialStore();
classeStore.fetch();

const props = defineProps({ modelValue: {} });

const proc = computed(() => props.modelValue.numero);
const classe = computed(() =>
    classeStore.all.find(c => c.id == props.modelValue.classe)
);

</script>
